const initialState = {
  isLoadingScenarioCreate: false,
  isLoadingScenarioUpdate: false,
  isLoadingScenarioRemove: false,
  columnState: {
    columns: null,
    columnGroups: null,
  },
};

export default initialState;
